import styled from 'styled-components';
import { Layout as AntDesignLayout } from 'antd';

/**
 * Antd Layout usa <section> por padrão — HTML5 proíbe <main>/<footer>
 * dentro de <section> (AccessMonitor landmark_08 / landmark_06 / landmark_04).
 * tagName="div" mantém o LayoutContext do Sider sem criar landmark.
 */
export const Layout = styled(AntDesignLayout).attrs({
  tagName: 'div',
})`
  min-height: 100vh;
  overflow-y: hidden;
`;
